import { render } from "preact";
import { App } from "./App.js";
import "./styles/app.css";

if (import.meta.env.DEV) {
  import("preact/debug");
}

render(<App />, document.getElementById("app")!);
